import React from 'react';

import { AddAutomationButton } from './add-automation-button';

const isApplicantSection = (section: string): section is ApplicantAutomationSection =>
  ['application', 'hiring', 'onboarding'].includes(section);

export const AutomationSectionEmptyState = ({
  section,
  org,
  job,
}: {
  section: ApplicantAutomationSection | 'employee' | 'birthday';
  org: Org;
  job?: Job;
}) => {
  let sectionTitle;
  switch (section) {
    case 'application':
      sectionTitle = 'application process';
      break;
    case 'hiring':
      sectionTitle = 'hiring process';
      break;
    case 'employee':
      sectionTitle = 'employee tenure';
      break;
    default:
      sectionTitle = section;
  }

  return (
    <div className="u-width-100 u-display-flex u-flexDirection-column u-alignItems-center u-margin-bottom-lg">
      <div className="typo-title u-margin-bottom">
        You currently have no {sectionTitle} automations set up
      </div>
      <AddAutomationButton
        variant="large"
        triggerType="applicant"
        org={org}
        editingForJob={job}
        section={isApplicantSection(section) ? section : undefined}
      />
    </div>
  );
};
